export default __webpack_public_path__ + "static/media/bug.08737c93.svg";